<div class="modal-header">
  <h4 class="modal-title">{{ "Save measurement" | translate }}</h4>
  <button (click)="dismiss()" class="btn-close" aria-label="Close" type="button"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>
  <button [disabled]="form.invalid" (click)="save()" class="btn btn-primary" type="button">
    {{ "Save" | translate }}
  </button>
</div>
